"use strict";

export function initInScope ($scope) {
    $scope.find('.js-open-cookie-settings').each(function(index) {
        $(this).on("click", function(){
            CookieConsent.renew();
        });
    });
}